import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-bris-machine',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-bris-machine.component.html',
  styleUrls: ['./assurance-bris-machine.component.scss']
})
export class AssuranceBrisMachineComponent {
  title = 'Assurance Bris de Machine';
  subtitle = '';
  phoneNumber = '01 43 27 12 43';
  heroImage = 'assets/static_pages_images/bris.jpg';

  breadcrumbs = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance Bris de Machine', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Multirisque Immeuble - MRI - PNE',
    link: '/assurance-multirisque-immeuble-pro'
  };

  nextPage = { 
    title: 'Assurance Cyberattaque Informatiques',
    link: '/assurance-cyber-risque'
  };
}
